import React, { createContext } from "react";

interface LangCTX {
  locale: string;
  changeLocale: React.Dispatch<React.SetStateAction<string>>;
}

export const LanguageContext = createContext<LangCTX>({
  locale: "",
  changeLocale: () => {},
});
